import "./index.scss";
import { useSelector } from "react-redux";

import * as PR from "../../prime-modules/index";
import getAssets from "../../assets/data/brandingAssets.json";
import { useState, useRef } from "react";
import { notifyEmail } from "../../services/api";
import { useToast } from "../../context/ToastContext";
import { useFormik } from "formik";
import * as Yup from "yup";

let { user_maintenance } = getAssets.home;

const UnderMaintenance = () => {
  const { labels } = useSelector((state) => state.language?.activelang);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const { showToast } = useToast();
  const { userData } = useSelector(state => state.auth);

  const handleSubmit = (values, { resetForm }) => {
    setLoading(true);
    notifyEmail({ email: values.email })
      .then(() => {
        setLoading(false);
        showToast("success", "We will notify you once we are back online.");
        resetForm();
      })
      .catch((err) => {
        setLoading(false);
        showToast("error", err?.message);
      });
  };

  const formik = useFormik({
    initialValues: { email: userData?.email || "" },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: handleSubmit,
  });

  return (
    <>
      <PR.Toast ref={toast} />
      <div className="under-maintenance-section">
        <div className="container">
          <div className="grid grid-nogutter custom-margin">
            <div className="col-12 lg:col-6">
              <h1>{labels?.LBLN0259}</h1>
              <p>{labels?.LBLN0260}</p>
              <form
                onSubmit={formik.handleSubmit}
                className="notify-form"
                autoComplete="off"
              >
                <PR.InputText
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter your email"
                  type="email"
                  className="notify-input"
                />
                <PR.Button
                  label="Notify Me"
                  icon={loading ? "pi pi-spin pi-spinner" : "pi pi-envelope"}
                  disabled={loading}
                  className="notify-button"
                />
              </form>
            </div>
            <div className="col-12 lg:col-6 text-center">
              <PR.Image
                src={user_maintenance}
                alt="404 error"
                className="error-image"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default UnderMaintenance;
